import { useQuery } from "@tanstack/react-query";

import { api, queryKeys } from "../api/client";

export function useHealth(enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.health,
    queryFn: api.health,
    enabled,
    refetchInterval: 60_000,
  });
}
